module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_10"
    }
  }, [_vm._v("Epigraph")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The reward of the search is to go on searching. The soul’s desire is fulfilled by the very fact of its remaining unsatisfied, for really to see God is never to have had one’s fill of desiring Him.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("Gregory of Nyssa")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9d38f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/epigraph.vue
// module id = 75
// module chunks = 0